import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as T from "utils/types";
import * as API from 'app/public_api';

export const cntPerPage = 10;

const initList = createAsyncThunk(
    'smtPubTab/initList', 
    async (
        data:{
            keywordType: T.keywordType,
            searchInput: T.searchInput,
            facultyID: number,
            departmentID: number,
        }, 
        thunkAPI
    )=>{
        const {
            keywordType, searchInput, 
            facultyID, departmentID, 
        } = data;
        const {currentPage}= (thunkAPI.getState() as T.RootState).smtPubTab;
        return await API.rSmtPubList(
            searchInput,
            keywordType,
            currentPage+1,
            departmentID,
            facultyID,
        );
    }
)
const loadMore = createAsyncThunk(
    'smtPubTab/rSmtPubList', 
    async ( data, thunkAPI
    )=>{
        const {
            keywordType,
            searchInput,
            facultyID,
            departmentID,
        } = (thunkAPI.getState() as T.RootState).searchPgUserInputs;
        const {currentPage}= (thunkAPI.getState() as T.RootState).smtPubTab;
        return await API.rSmtPubList(
            searchInput,
            keywordType,
            currentPage+1,
            departmentID,
            facultyID,
        );
    }
)

export const smtPubTabThunks = {initList, loadMore};

export const initialState: T.SmtPubTab = {
    total: -1,
    smtPubList: [],
    currentPage: 0,
    hasNext: true,
    status: 'idle',
    errorMsg: null,
    currentRequestId: null,
}

// publication tab slice
export default createSlice({
    name: 'smtPubTab',
    initialState,
    reducers: {},
    extraReducers: builder=>{

        // initList thunk (this maybe called by other component, so it has this init steps)
        builder.addCase(initList.pending, (state, action) => {

            state.currentPage = initialState.currentPage;
            state.hasNext = initialState.hasNext;

            state.status = 'loading';
            state.errorMsg = initialState.errorMsg;
            state.currentRequestId = action.meta.requestId;

            // set the list to be cntPerPage skeleton items
            state.smtPubList = [
                ...new Array(cntPerPage)
            ].map(()=>({loading: true, item: null}));
        });
        builder.addCase(initList.fulfilled, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'succeeded';

                const {links, total_result, results} = action.payload            

                state.total = total_result;
                state.hasNext = !!links.next;
                state.currentPage += 1;

                // set the list to what we received
                state.smtPubList = results.map(
                    x=>({loading:false, item: x})
                );

            }
        });
        builder.addCase(initList.rejected, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'failed';
                state.errorMsg = action.error.message;
            }
        });

        // loadMore thunk
        builder.addCase(loadMore.pending, (state, action) => {
            state.status = 'loading';

            // add cntPerPage skeleton items to the list
            state.smtPubList = state.smtPubList.concat( 
                [...new Array(cntPerPage)].map(()=>({loading:true, item: null}))
            );
        });
        builder.addCase(loadMore.fulfilled, (state, action) => {
            state.status = 'succeeded';

            const {links, total_result, results} = action.payload            

            state.total = total_result;
            state.hasNext = !!links.next;
            state.currentPage += 1;

            // replace the last cntPerPage skeleton item list 
            // to the list we received
            state.smtPubList = state.smtPubList.slice(0, -cntPerPage).concat( 
                results.map(x=>({loading:false, item: x}))
            );
        });
        builder.addCase(loadMore.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });
    }
});
